import React, { useState, useEffect, useContext, memo } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import TabHeader from "components/MBM/TabHeader";
import MBMTabs from "components/MBM/MBMTabs";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import postPageVisit from "services/LogService";

function MBM() {
  const [redirState, setRedirState] = useState(false);
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, setPage, selectedNodesInfo } = appContext;

  useEffect(() => {
    setPage('mbm');
    postPageVisit('mbm');
  }, []);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/mbm",
      }}
    />
  );
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"mbm"}
    >
      {chartIdGroup[0] !== "0" ? (
        <>
          <TabHeader entiteName={selectedNodesInfo} />
          <MBMTabs />
        </>
      ) : <TabHeader entiteName={""} />
      }
      {redirecting}
    </ErrorBoundary>
  );
}

export default MBM;
